import { render, staticRenderFns } from "./dialogUserSetting.vue?vue&type=template&id=3a97b385&scoped=true"
import script from "./dialogUserSetting.vue?vue&type=script&lang=js"
export * from "./dialogUserSetting.vue?vue&type=script&lang=js"
import style0 from "./dialogUserSetting.vue?vue&type=style&index=0&id=3a97b385&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a97b385",
  null
  
)

export default component.exports